import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, gql } from '@apollo/client';
import SalesOrderConvertToSerializedPickScan from './SalesOrderConvertToSerializedPickScan';
import { Spinner, alert } from 'equasion-lib';
import { BULK_PRODUCT_STATUS_UPDATE } from '@/lib/graphql/fragments';

const CLIENT_ORDER = gql`
  query salesOrder(
    $id: ID
    $status: Int!
    $salesOrderItemId: ID!
    $lot: String
    $quantity: Int
    $locationId: ID
  ) {
    salesOrder(id: $id) {
      id
      salesOrderNumber
      status
      partiallyPicked
      salesOrderItem(salesOrderItemId: $salesOrderItemId) {
        id
        quantity
        serializedItemOfStatusCount(status: $status)
        productPackagingKind {
          id
          name
          ndcPackageCode
          topPriorityLocations {
            id
            name
            priority
          }
        }
      }
    }
    unserializedProductToSerializedLookup(
      salesOrderItemId: $salesOrderItemId
      lot: $lot
      quantity: $quantity
      locationId: $locationId
    ) {
      id
      lot
      expiration
      location {
        id
        name
      }
    }
  }
`;

const SERIALIZE_UNSERIALIZED_PRODUCTS = gql`
  mutation serializeUnserializedProducts(
    $unserializedProducts: [ProductAttributes]!
    $locationId: ID!
    $lot: String!
    $salesOrderId: ID!
  ) {
    serializeUnserializedProducts(
      unserializedProducts: $unserializedProducts
      locationId: $locationId
      lot: $lot
      salesOrderId: $salesOrderId
    )
  }
`;

const SalesOrderConvertToSerializedPickScanData = (props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const salesOrderId = searchParams.get('salesOrderId');
  const salesOrderItemId = searchParams.get('salesOrderItemId');
  const lot = searchParams.get('lot');
  const quantity = searchParams.get('quantity');
  const locationId = searchParams.get('locationId');
  const [bulkProductStatusUpdate] = useMutation(BULK_PRODUCT_STATUS_UPDATE);
  const [serializeUnserializedProducts] = useMutation(SERIALIZE_UNSERIALIZED_PRODUCTS);

  const { data, error, loading, refetch } = useQuery(CLIENT_ORDER, {
    variables: {
      id: salesOrderId,
      salesOrderItemId,
      status: 16,
      lot,
      quantity: parseInt(quantity),
      locationId
    },
    fetchPolicy: 'network-only'
  });

  const returnToPickScan = () =>
    navigate(
      `/sales-order-pick-scan?salesOrderId=${salesOrderId}&salesOrderItemId=${salesOrderItemId}`
    );

  useEffect(() => {
    if (error) {
      alert('Error', error.message.substring(0, 50), 4, 'error');
      returnToPickScan();
    }
  }, [error, loading]);

  if (loading) return <Spinner />;
  if (error) return <div />;

  const { salesOrder, unserializedProductToSerializedLookup } = data || {};

  return (
    <SalesOrderConvertToSerializedPickScan
      bulkProductStatusUpdate={bulkProductStatusUpdate}
      serializeUnserializedProducts={serializeUnserializedProducts}
      salesOrder={salesOrder}
      unserializedProduct={unserializedProductToSerializedLookup}
      refetch={refetch}
      quantity={quantity}
      {...props}
    />
  );
};

export default SalesOrderConvertToSerializedPickScanData;
